export default __webpack_public_path__ + "static/media/marauders-map-v5.1-02-01.59ddf88f.jpg";